export class Privilege {
  constructor(
    public hash?: string,
    public name?: string,
    public defaultPrivilege?: boolean
  ) { }

  clone() {
    return new Privilege(
      this.hash,
      this.name,
      this.defaultPrivilege
    );
  }

  get translatingName() {
    return `dashboard.privileges.${(this) ? this.name : ''}`;
  }

  get translatingDescription() {
    return `dashboard.privileges.descriptions.${(this) ? this.name : ''}`;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/privilege.ts